import { Col, Form, Row,ListGroup,Button } from "react-bootstrap";
import { HeaderRegister } from "../../../components/HeaderRegister";
import { MultiEquipmentGroupService } from "../../../services/multiequipmentgroup.service";
import { useEffect, useRef, useState } from "react";
import { ToastService } from "../../../services/toast.service";
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from "react-router-dom";
import { FieldArray, Formik } from "formik";
import * as yup from 'yup';
import { MultiEquipmentGroupModel } from "../../../models/multiequipmentgroup.model";
import EquipmentService from "../../../services/equipment.service";
import { EquipmentModel } from "../../../models/equipment.model";
import _ from "lodash";
import storageService from "../../../services/storage.service";
import Select from 'react-select';
import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import {
  RequestInputOutputParamsModel,
  RequestInputOutputParamsModelDefault,
} from "../../../models/requestInputOutputParams.model";

const MultiEquipmentGroupRegister = () => {
    const user = storageService.getUser();
    const [equipmentList, setEquipmentList] = useState<EquipmentModel[]>([]);
    const { id } = useParams<{ id?: string }>();
    const [initialValues, setInitialValues] = useState<MultiEquipmentGroupModel>({
        id: 0,
        name: '',
        description: '',
        SelectedEquipmentIdList: [],
    });

    const [data, setData] = useState<DatasetModel>();
    const [dataset, setDataset] = useState<DatasetModel>({
        ...JSON.parse(JSON.stringify(DatasetDefault)),
        dataset: "equipment",
        filters: {
        transporter_id: [],
        branch_id: [],
        locale_id: [],
        code_equipment: [],
        equipment_status_id:[],
        customer: [],
        multiequipmentgroup:[true],
        },
        sort: {
        field: "codeEquipment",
        orientation: "asc",
        },
    });


    const [isLoading, setLoading] = useState(false);
    const { t } = useTranslation();
    const formRef = useRef();
    const history = useHistory();
    const onSubmit = async (data) => {

            // Gera a lista de IDs dos equipamentos marcados
        const selectedEquipmentIds = equipmentListMulti
            .filter(item => item.checkboxSelected === true)
            .map(item => item.Id);

        // Preenche o campo no objeto a ser enviado
        const finalData = {
            ...data,
            selectedEquipmentIdList: selectedEquipmentIds,
        };

        if (Number(id)) {
            await update(finalData);
        } else {
            await create(finalData);
        }
    };
    const create = async (data) => {               
        try {
            const response: any = await MultiEquipmentGroupService.insert(data);
            if (response.success) {
                ToastService.success(t('MULTI_EQUIPMENT_GROUP.INSERTED'));
                history.push(`/equipment/multiequipmentgroup`);
            }
        } catch (error) {
            console.log(error);
            ToastService.error(t('ERROR_GENERIC'));
        }
    };
    const update = async (data) => {
        try {
            data.id = Number(id);
            const response: any = await MultiEquipmentGroupService.update(data);
            if (response.success) {
                ToastService.success(t('MULTI_EQUIPMENT_GROUP.UPDATED'));
                history.push(`/equipment/multiequipmentgroup`);
            }
        } catch (error) {
            console.log(error);
            ToastService.error(t('ERROR_GENERIC'));
        }
    };

    const [selectedEquipment, setSelectedEquipment] = useState(null);
    const [equipmentListMulti, setEquipmentListMulti] = useState([]);
    const [inputValue, setInputValue] = useState(null);

    const handleAddEquipment = () => {

    if (selectedEquipment == null)
        {
            ToastService.warn(t('MULTI_EQUIPMENT_GROUP.ERROR_EQUIPMENT_REQUIRED'),null);
        } 
    else if (
        selectedEquipment &&
        !equipmentListMulti.find(eq => eq.Id === selectedEquipment.value)
    ) {

            // Buscar o equipamento completo em equipmentList pelo código
        const equipmentFull = equipmentList.find(
            item => item.id === selectedEquipment.value
        );

        const newItem = {
        Id: selectedEquipment.value,
        codeEquipment: selectedEquipment.label,
        checkboxSelected: true,
        addressStreet: equipmentFull ? equipmentFull.addressStreet : "", // busca o endereço
        addressCity: equipmentFull ? equipmentFull.addressCity : "", // busca a cidade
        };

        setEquipmentListMulti(prev => [...prev, newItem]);
          // Limpa o valor selecionado do Select
        setSelectedEquipment(null);
    } else {
        ToastService.warn(t('MULTI_EQUIPMENT_GROUP.ERROR_ASSOCIATION'),null);
    }
    };

    // useEffect(() => {
        
    // }, [equipmentListMulti]);

    const initialize = async () => {

        const getList = async (dataTable, datasetOverride = null) => {
            setLoading(true);

            let requestParams: RequestInputOutputParamsModel = {
            ...RequestInputOutputParamsModelDefault,
            datasets: [datasetOverride || dataset],
            };

            if (dataTable !== null && requestParams?.datasets) {
            let dataSet = requestParams.datasets[0];

            let pagination = dataSet.pagination;

            pagination.page_number = dataTable.page_number;
            pagination.records_pages = dataTable.page_size;
            dataSet.sort.field = dataTable.sort_order.column;
            dataSet.sort.orientation = dataTable.sort_order.order;
            } else {
            let pagination = requestParams.datasets[0].pagination;
            pagination.page_number = DatasetDefault.pagination.page_number;
            pagination.records_pages = DatasetDefault.pagination.records_pages;
            }

            const response: any = await EquipmentService.getList(requestParams);

            if (response.success === true && response.result) {
            let d: DatasetModel = _.last(
                _.filter(response.result.datasets, { dataset: "equipment" })
            );
            setLoading(false);
            return d.data;

            }
            setLoading(false);
        };

        const responseEquipment: any = (await getList(null));

        setEquipmentList(responseEquipment);
        
    };
    useEffect(() => {
        initialize();
    }, []);

    useEffect(() => {
    const fetchData = async () => {
        if (Number(id) && equipmentList.length > 0) {
            const response: any = await MultiEquipmentGroupService.getById(id);

            if (response?.result) {
                setEquipmentListMulti([]);
                setInitialValues(response.result);

                const selectedIds = response.result.selectedEquipmentIdList || [];

                const selectedEquipments = selectedIds.map(id => {
                    const equipmentFull = equipmentList.find(item => item.id === id);
                    return {
                        Id: id,
                        codeEquipment: equipmentFull ? equipmentFull.codeEquipment : "",
                        checkboxSelected: true,
                        addressStreet: equipmentFull ? equipmentFull.addressStreet : "",
                        addressCity: equipmentFull ? equipmentFull.addressCity : "",
                    };
                });
                setEquipmentListMulti(selectedEquipments);
            }
        }
    };

    fetchData();
}, [id, equipmentList]);


    const schema = yup.object().shape({
        name: yup.string().required(t('REQUIRED')),
        description: yup.string().required(t('REQUIRED'))
    });
    const submitFormik = () => {
        if (formRef && formRef.current) {
            let current: any = formRef.current;
            current.handleSubmit();
        }
    }

    const equipmentOptions = equipmentList.map(item => ({
        label: item.codeEquipment, // ou newCodeEquipment, se preferir
        value: item.id  // ou item.id, se tiver
    }));
  
    return (
        <>
            {/* {JSON.stringify(branchList, null, 2)} */}
            <HeaderRegister title={`${t('MENU_MULTI_EQUIPMENT_GROUP')} | ${window.location.hash.includes("add") ? t("REGISTRATION") : t("EDITION")}`} path={"/equipment/multiequipmentgroup"} submitForm={submitFormik} isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}/>
            <Formik
                enableReinitialize={true}
                innerRef={formRef}
                initialValues={initialValues}
                validationSchema={schema}
                onSubmit={(values, actions) => {
                    onSubmit(values);
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Row>
                            {/* {JSON.stringify(values)}
                            {JSON.stringify(errors)} */}
                            <Col xs={12} xl={12}>
                                <Row className="align-items-center">
                                    <Col sm={12} md={6} lg={3} className="mb-4">
                                        <Form.Group>
                                            <Form.Floating>
                                                <Form.Control
                                                    name='name'
                                                    id='name'
                                                    type='text'
                                                    placeholder={t('MULTI_EQUIPMENT_GROUP.NAME')}
                                                    maxLength={100}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={isLoading}
                                                    isInvalid={touched.name && !!errors.name}
                                                    value={values.name}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.name}
                                                </Form.Control.Feedback>
                                                <Form.Label>{t('MULTI_EQUIPMENT_GROUP.NAME')}</Form.Label>
                                            </Form.Floating>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={12} md={6} lg={3} className="mb-4">
                                        <Form.Group>
                                            <Form.Floating>
                                                <Form.Control
                                                    name='description'
                                                    id='description'
                                                    type='text'
                                                    placeholder={t('MULTI_EQUIPMENT_GROUP.DESCRIPTION')}
                                                    maxLength={150}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={isLoading}
                                                    isInvalid={touched.description && !!errors.description}
                                                    value={values.description}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.description}
                                                </Form.Control.Feedback>
                                                <Form.Label>{t('MULTI_EQUIPMENT_GROUP.DESCRIPTION')}</Form.Label>
                                            </Form.Floating>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                        <Col xs={12} xl={12}>
                            <Row className="align-items-center">
                            <Col sm={12} md={6} lg={6} className="mb-4">
                                <div className="mb-2">{t('MENU_EQUIPMENTS')}</div>

                                <FieldArray
                                name="selectedequipmentIdlist"
                                render={arrayHelpers => (
                                    <>
                                    <div className="d-flex align-items-center gap-2 mb-3">
                                    <Select
                                        placeholder={t("FILTER.EQUIPMENT")}
                                        options={equipmentOptions}
                                        value={selectedEquipment}
                                        onChange={setSelectedEquipment}
                                        onInputChange={(value) => setInputValue(value)}  // captura o texto digitado
                                            onBlur={() => {

                                                const trimmedInput = (inputValue || '').trim();

                                                const selcustomOption = equipmentOptions.find(option => option.label === trimmedInput);
                                                if (!selcustomOption && trimmedInput && (!selectedEquipment || selectedEquipment.label !== trimmedInput)) {
                                                    setSelectedEquipment(null);
                                                }
                                                else if (selcustomOption) {
                                                    setSelectedEquipment(selcustomOption);
                                                }
                                                // Se não selecionou nenhuma opção mas digitou algo
                                                if (!selectedEquipment && trimmedInput !== "") {
                                                    const customOption = equipmentOptions.find(option => option.label === trimmedInput);
                                                    if (customOption !== null && customOption !== undefined) {
                                                        // Define a seleção como a opção existente encontrada
                                                        setSelectedEquipment(customOption);
                                                    }
                                                    else
                                                    {
                                                        setSelectedEquipment(null);
                                                    }
                                                }
                                            }}
                                        className="flex-grow-1"
                                    />
                                        <Button onClick={handleAddEquipment}>
                                            <span>{t("MULTI_EQUIPMENT_GROUP.ASSOCIATION")}</span>
                                        </Button>
                                    </div>

                                    {/* Lista de checkboxes */}
                                    {equipmentListMulti.map((equipment, index) => (
                                        <div key={index}>
                                        <Form.Check
                                            type="checkbox"
                                            label={`${equipment.codeEquipment} - ${equipment.addressStreet}  - ${equipment.addressCity}`}
                                            name="SelectedEquipmentIdList"
                                            checked={equipment.checkboxSelected}
                                            onChange={e => {
                                                const checked = e.target.checked;
                                                setEquipmentListMulti(prev =>
                                                prev.map((item, i) =>
                                                    i === index ? { ...item, checkboxSelected: checked } : item
                                                )
                                                );
                                            }}
                                        />
                                        </div>
                                    ))}
                                    </>
                                )}
                                />
                            </Col>
                            </Row>
                        </Col>
                        </Row>

                    </Form>
                )}
            </Formik>
        </>
    );
};
export default MultiEquipmentGroupRegister;